<template>
    <div id="loader-wrapper" class="CPreLoader fixed left-0 top-0 z-[1000] size-full" :class="{ 'loaded': loaded }">
        <div class="loader"></div>

        <div class="loader-section section-left fixed left-0 top-0 z-[1000] h-full w-[51%] bg-primary-50 dark:bg-primary-950/40"></div>
        <div class="loader-section section-right fixed right-0 top-0 z-[1000] h-full w-[51%] bg-primary-50 dark:bg-primary-950/40"></div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    loaded: boolean
}>()
</script>
